// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceCloudFog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17.122 12 .12-.01a3 3 0 1 0-.537-5.976l-1.292.125a.25.25 0 0 1-.256-.153l-.494-1.2A4.502 4.502 0 0 0 6 6.5v.025l.005 1.015a.25.25 0 0 1-.124.218L5 8.266a2 2 0 0 0 .922 3.732l.039.002zm.27 2H5.85l-.001-.001-.002-.002A4 4 0 0 1 3.97 6.553.061.061 0 0 0 4 6.5a6.5 6.5 0 0 1 12.438-2.647c.045.1.149.163.258.156a5 5 0 0 1 .71 9.975.008.008 0 0 0-.006.008.008.008 0 0 1-.008.008zm.108 2a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-12A.5.5 0 0 1 5 17v-.5a.5.5 0 0 1 .5-.5zm0 3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-12A.5.5 0 0 1 5 20v-.5a.5.5 0 0 1 .5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceCloudFog;
